import type { TUseRequestUpdaterProps } from 'features/request/useRequest';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractSubObjectCreateInput, UerCreateWorkOrderChangeSubObjectMutation } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerCreateWorkOrderChangeSubObjectGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerCreateWorkOrderChangeSubObject';

export const useUerCreateWorkOrderChangeSubObject = (
    workOrderChangeId?: number,
    onSuccess?: (newObjectId?: number) => void,
) => {
    const dispatch = useDispatch();

    const [uerCreateWorkOrderChangeSubObjectReset] = useResetStoreData({ requestId });

    const onCreateSuccess = useCallback(
        (depsVars: TUseRequestUpdaterProps<UerCreateWorkOrderChangeSubObjectMutation>) => {
            uerCreateWorkOrderChangeSubObjectReset(undefined);
            onSuccess?.(depsVars?.payload?.uerCreateWorkOrderChangeSubObject?.id);
        },
        [onSuccess, uerCreateWorkOrderChangeSubObjectReset],
    );

    const [, uerCreateWorkOrderChangeSubObjectStatus, , uerCreateWorkOrderChangeSubObjectRequest] = useRequest({
        requestId,
        query: uerCreateWorkOrderChangeSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onCreateSuccess,
    });

    const uerCreateWorkOrderChangeSubObjectMakeRequest = useCallback(
        (input: ContractSubObjectCreateInput) => {
            dispatch(uerCreateWorkOrderChangeSubObjectRequest({ workOrderChangeId, input }));
        },
        [dispatch, uerCreateWorkOrderChangeSubObjectRequest, workOrderChangeId],
    );

    useEffect(() => {
        uerCreateWorkOrderChangeSubObjectReset(undefined);
    }, [uerCreateWorkOrderChangeSubObjectReset]);

    return {
        uerCreateWorkOrderChangeSubObjectStatus,
        uerCreateWorkOrderChangeSubObjectMakeRequest,
    };
};
